import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { EventGallery } from '../components/EventGallery';
import { OpeningLead } from '../components/OpeningLead';
import { DreamSection } from '../components/DreamSection';
import { MirrorReveal } from '../components/MirrorReveal';
import { OurStory } from '../components/OurStory';
import { BenefitsTable } from '../components/BenefitsTable';
import { Testimonials } from '../components/Testimonials';
import { PackageList } from '../components/PackageList';
import { Guarantee } from '../components/Guarantee';
import { Urgency } from '../components/Urgency';
import { BookingCalendar } from '../components/BookingCalendar';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-ink font-sans text-cream selection:bg-gold/30 selection:text-white" data-id="element-484">
      <Header data-id="element-485" />
      <main data-id="element-486">
        <Hero data-id="element-487" />
        <EventGallery data-id="element-488" />
        <OpeningLead data-id="element-489" />

        <DreamSection data-id="element-490" />

        <MirrorReveal data-id="element-491" />
        <OurStory data-id="element-492" />
        <BenefitsTable data-id="element-493" />
        <Testimonials data-id="element-494" />
        <PackageList data-id="element-495" />
        <Guarantee data-id="element-496" />
        <Urgency data-id="element-497" />
        <BookingCalendar data-id="element-498" />
        <FinalCTA data-id="element-499" />
        <FAQ data-id="element-500" />
      </main>
      <Footer data-id="element-501" />
    </div>;
}